"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThinkificService = void 0;
const environment_enum_1 = require("../enum/environment.enum");
const axios_1 = __importDefault(require("axios"));
const environment_1 = require("../../constants/environment");
class ThinkificService {
    constructor(ENV = environment_enum_1.ENVIRONMENT.DEV, key) {
        this.postCreateCatalogs = async (body) => {
            const URL = `${environment_1.API_URL_BASE_V2}/${this.ENV}/thinkific/catalogs`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.postCreateCertifications = async (body) => {
            const URL = `${environment_1.API_URL_BASE_V2}/${this.ENV}/thinkific/certifications`;
            const response = await axios_1.default.post(URL, body, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getCatalogs = async (params) => {
            const queryString = this.objectToQueryString(Object.assign({}, params));
            const URL = `${environment_1.API_URL_BASE_V2}/${this.ENV}/thinkific/catalogs?${queryString}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getMicrocredentials = async (params) => {
            const queryString = this.objectToQueryString(Object.assign({}, params));
            const URL = `${environment_1.API_URL_BASE_V2}/${this.ENV}/thinkific/microcredentials?${queryString}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.updateCatalogs = async (params) => {
            const queryString = this.objectToQueryString(Object.assign({}, params));
            const URL = `${environment_1.API_URL_BASE_V2}/${this.ENV}/thinkific/catalogs?${queryString}`;
            const response = await axios_1.default.put(URL, params, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.objectToQueryString = (obj) => Object.keys(obj).map(key => {
            const value = obj[key];
            let parameter = `${key}=${value}`;
            if (Array.isArray(value)) {
                let multiValueParams = '';
                const lastIndex = value.length - 1;
                value.forEach((item, index) => multiValueParams += `${key}=${item}${index === lastIndex ? '' : '&'}`);
                return multiValueParams;
            }
            return parameter;
        }).join("&");
        this.ENV = ENV;
        this.KEY = key;
    }
}
exports.ThinkificService = ThinkificService;
